// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { defineMessages, WrappedComponentProps, injectIntl } from "react-intl";

import { IState } from "states/states";
import { IAction, ActionType, raiseAction } from "actions";

import MonitorGraph from "view/comp/MonitorGraph";
import ControlCircuitSelect from "view/comp/ControlCircuitSelect";

interface IMonitorProps {}

const mapStateToProps = (state: IState) => {
  const props: IMonitorProps = {};
  return props;
};

interface IMonitorDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IMonitorDispatch = {};
  return dispatchProps;
};

const messages = defineMessages({});

class MonitorComponent extends React.Component<
  IMonitorProps & IMonitorDispatch & WrappedComponentProps
> {
  public render() {
    return (
      <div id="monitor" className="flex-self flex-content graph-shrink">
        <ControlCircuitSelect />
        <MonitorGraph />
      </div>
    );
  }
}

const Monitor = connect(mapStateToProps, mapDispatchToProps)(MonitorComponent);

export default injectIntl(Monitor);
